var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payment-fifth-border" }, [
      _c("div", { staticClass: "payment-fifth-content-parent" }, [
        _c("div", { staticClass: "payment-fifth-content-img" }, [
          _c("img", {
            attrs: { src: require("../../assets/payment-fifth-1x.png") }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "payment-fifth-content-text" }, [
          _c("div", { staticClass: "payment-fifth-content-text-title" }, [
            _vm._v("More inventory means more sales")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "payment-fifth-content-text-main" }, [
            _vm._v(
              "“Net 60 has played a big part in helping my business grow. It helps me use my cash everywhere I need to, and bring in more brands quicker than before. Love our reps, but if I can get net 60 I mean, HELLO.”"
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "payment-fifth-content-text-bottom-border" },
            [
              _c("div", { staticClass: "payment-fifth-content-text-bottom1" }, [
                _vm._v("Jasmine Helen")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "payment-fifth-content-text-bottom2" }, [
                _vm._v("Cleanse Apothecary")
              ])
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-780d3fd2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-780d3fd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/credit-payment/payment-fifth.vue
// module id = null
// module chunks = 